import { LockIcon } from '@/components/Icons/LockIcon';
import { LunarLevelImage } from './LunarLevelImage';
import './LevelCard.css';

interface LevelCardProps {
  levelId: string;
  name: string;
  description: string;
  imageUrl?: string;
  isUnlocked: boolean;
  onSelect: (levelId: string) => void;
}

export function LevelCard({
  levelId,
  name,
  description,
  imageUrl,
  isUnlocked,
  onSelect,
}: LevelCardProps) {
  const handleClick = () => {
    if (isUnlocked) {
      onSelect(levelId);
    }
  };

  return (
    <div
      className={`level-card ${isUnlocked ? 'unlocked' : 'locked'}`}
      onClick={handleClick}
    >
      {/* Level Image */}
      <div className="level-image">
        {/* Use custom canvas animation for Lunar level */}
        {levelId === 'lunar' ? (
          <LunarLevelImage />
        ) : imageUrl ? (
          <img src={imageUrl} alt={name} className="level-img" />
        ) : null}
        
        {!isUnlocked && (
          <div className="lock-overlay">
            <LockIcon />
          </div>
        )}
      </div>

      {/* Level Info */}
      <div className="level-info">
        <h3 className="level-name">{name}</h3>
        <p className="level-description">{description}</p>
        {!isUnlocked && (
          <div className="level-status">Locked</div>
        )}
      </div>
    </div>
  );
}

